import styled from 'styled-components';

export const GoSafeWrap = styled.section`
    border: 1px solid #e3e3e3;
    border-radius: 0.6rem;
    padding: 0 1rem 1rem;
    margin: 2rem 0 1rem;
`
export const GoSafeTitle = styled.div`
  color: #2bac36;
  font-size: 1.4rem;
  border-radius: 0.4rem;
  background-color: #e9f6ea;
  padding: 0.5rem;
  display: inline-flex;
  margin-top: -1rem;
`;

export const GoSafeHeader = styled.div(
    props => `
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 1rem 0;
    span {
        font-weight: bold;
        font-size: 1.4rem;
        font-family: ${props.theme.font.fontFamily};
        padding-left: 0.5rem
    }
`
)
export const GoSafeCarousel = styled.div`
   
`
export const GoSafeCarouselUL = styled.ul`
        display: flex;
        flex-direction: row;
        overflow-x: auto;
    
`
export const GoSafeCarouselLI = styled.li`

    margin-right: 0.5rem;
    width: 255px;
    height: 110px;
    border-radius: 0.8rem;
    border: solid 1px #b5f5ac;
    background-color: white;
    display: flex;
    flex-direction: row;
    padding: 1rem

`
export const CardContent = styled.aside`
    display: flex;
    flex-direction: column
`
export const CardHeader = styled.p`
    font-weight: bold;
    color: black;
    font-size: 1.4rem;
    padding-bottom: 0.7rem;
`
export const CardInfo = styled.p`
    font-size: 1.2rem;
    color: #647a97;
    
    
`
